import React from 'react'
import { Button } from '@deal/components'
import AppStoreIcon from './app-store.svg'
import cookies from 'js-cookie'
import styles from './styles.css'
import CloseIcon from './close.svg'
// @ts-ignore no typings
import Scrolllock from 'react-scrolllock'
import config from '#src/config'

interface IOSFullPageTakeoverProps {}

interface IOSFullPageTakeoverState {
  hasModalBeenViewed: boolean
}

class IOSFullPageTakeover extends React.Component<
  IOSFullPageTakeoverProps,
  IOSFullPageTakeoverState
> {
  constructor(props: IOSFullPageTakeoverProps) {
    super(props)

    this.state = {
      hasModalBeenViewed: false
    }

    this.handleDismissModal = this.handleDismissModal.bind(this)
  }

  public componentDidMount() {
    if (!this.state.hasModalBeenViewed) {
      this.setState({
        hasModalBeenViewed: cookies.get('deal_ios_full_page_takeover_viewed') !== undefined
      })
    }
  }

  public handleSetCookie() {
    cookies.set('deal_ios_full_page_takeover_viewed', 'true', {
      // Expires in 24 hours
      expires: 1,
      domain: config.get('consumer.clientSideCookieDomain')
    })
  }

  public handleDismissModal() {
    this.setState(
      {
        hasModalBeenViewed: true
      },
      this.handleSetCookie
    )
  }

  public render() {
    if (this.state.hasModalBeenViewed) {
      return null
    }

    return (
      !this.state.hasModalBeenViewed && (
        <>
          <Scrolllock />
          <div className={styles.takeover}>
            <CloseIcon onClick={() => this.handleDismissModal()} className={styles.close} />
            <div className={styles.header}>Have your expert in your pocket</div>
            <div className={styles.title}>Download our free iOS app</div>
            <Button
              className={styles.button}
              onClick={() => (window.location.href = config.get('adjust.takeover'))}
            >
              Download for free
            </Button>
            <AppStoreIcon
              className={styles.icon}
              onClick={() => (window.location.href = config.get('adjust.takeover'))}
            />
          </div>
        </>
      )
    )
  }
}

export default IOSFullPageTakeover
